 
const IndexHandle = {
    name: 'index',
    components: { 
    },
    data() {
        return {
            fixNav: false,
            projectSecondary: false,
            projectTitle: false,
            workTitle: false,
            workAnimated: false,
            projectList: false,
            openPeopleTitle: false,
            openPeopleBox: false
        }
    },
    created() {
        window.scrollTo(0, 0);
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {

            if (this.$root.$el.getAttribute("data-platform") !== 'pc') {
                return false;
            }
            let currentScroll = window.pageYOffset;

            const top = this.$refs.navList.getBoundingClientRect().top;
            this.fixNav = top <= -20;

            if (this.$refs.projectTitle && currentScroll >= this.$refs.projectTitle.offsetTop - 800) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
                this.projectTitle = true;
            }
            if (this.$refs.projectSecondary && currentScroll >= this.$refs.projectSecondary.offsetTop - 1000) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
                this.projectSecondary = true;
            }
            if (this.$refs.workTitle && currentScroll >= this.$refs.workTitle.offsetTop - 500) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
                this.workTitle = true;
            }
            if (this.$refs.workTitle && currentScroll >= this.$refs.workTitle.offsetTop - 600) {
                this.workAnimated = true;
            }
            if (this.$refs.projectList && currentScroll >= this.$refs.projectList.offsetTop - 600) {
                this.projectList = true;
            }
            if (this.$refs.peopleTitle && currentScroll >= this.$refs.peopleTitle.offsetTop - 800) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
                this.openPeopleTitle = true;
            }



        },
    }
}
export default IndexHandle;